import qs from 'querystring';
import React from 'react';
import S from 'string';
import { Alert, Button } from 'antd';
import { propOr, assoc, replace, path } from 'ramda';
import { passwordIsValid } from '../../lib/validation';
import AccountLayout from '../../layout/account/AccountLayout';
import usePassword from '../../hooks/usePassword';
import PasswordInput from './components/PasswordInput';

const ResetPassword = ({
  location,
  history
}) => {
  const redirect = (route) => history.push(route);
  const onGotoSignIn = () => redirect('/account/signin');
  const onGotoResetPasswordRequest = () => redirect('/account/resetpasswordrequest');

  const getToken = () => {
    return propOr(
      undefined,
      'token',
      qs.parse(S(location.search).chompLeft('?').s)
    );
  };

  const {
    password,
    loading,
    error,
    sent,
    onResetPassword,
    setState
  } = usePassword(getToken());

  const isValid = passwordIsValid(password);

  return (
    <AccountLayout>
      <h3>Nouveau mot de passe</h3>

      {!sent && (
        <>
          <PasswordInput
            placeholder="Votre nouveau mot de passe"
            password={password}
            onChange={e => setState(assoc('password', replace(/\s/g, '', path(['target', 'value'], e))))}
            isValid={isValid}
          />
          <Button
            className="block mt-4"
            size="large"
            disabled={!isValid}
            onClick={onResetPassword}
            loading={loading}
            type="primary"
          >
            Confirmer
          </Button>
        </>
      )}

      {sent && !error && (
        <div>
          <Alert
            type="success"
            message="Votre mot de passe a bien été enregistré"
          />
          <br/>
          <Button
            onClick={onGotoSignIn}
            type="primary"
            size="large"
          >
            Me connecter
          </Button>
        </div>
      )}

      {error && (
        <div>
          <Alert
            type="error"
            message="Votre mot de passe n'a pas pu être mis à jour, veuillez réessayer"
          />
          <br/>
          <Button
            onClick={onGotoResetPasswordRequest}
            type="primary"
          >
            Changer mon mot de passe
          </Button>
        </div>
      )}

    </AccountLayout>
  );
};

export default ResetPassword;
